// extracted by mini-css-extract-plugin
module.exports = {"shippingAddress":"style_shippingAddress__3R0uh","title":"style_title__X47M9","spinning":"style_spinning__10CKv"};